// src/services/monthlyCompletions.js
// Thin client wrapper around GET /api/admin-monthly-completions.
// Admin-only — relies on the Clerk getToken passed in by the caller.
//
// Returns the report payload (see api/admin-monthly-completions.js) or throws
// an Error with the server message / HTTP status. No caching: the admin runs
// the report explicitly via a button, and fresh data is the expectation.

// countKind: 'classes' (membership workout classes only — the default) or
// 'all' (every completed workout, incl. shorts / program videos / Series days).
// Omitted entirely when not supplied so the server default governs.
export async function fetchMonthlyCompletions(month, threshold, getToken, countKind) {
    if (!month) throw new Error('month is required (YYYY-MM)');
    if (typeof getToken !== 'function') throw new Error('getToken is required');

    const params = new URLSearchParams({ month });
    if (threshold !== undefined && threshold !== null && threshold !== '') {
        params.set('threshold', String(threshold));
    }
    if (countKind) params.set('countKind', String(countKind));

    const token = await getToken();
    const res = await fetch(`/api/admin-monthly-completions?${params.toString()}`, {
        headers: { Authorization: `Bearer ${token}` },
    });
    if (!res.ok) {
        let detail = '';
        try { detail = (await res.json())?.error || ''; } catch (_) { /* defensive */ }
        throw new Error(detail || `HTTP ${res.status}`);
    }
    return res.json();
}
